var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThreeDotsVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.875 16.25C11.875 16.7473 11.6775 17.2242 11.3258 17.5758C10.9742 17.9275 10.4973 18.125 10 18.125C9.50272 18.125 9.02581 17.9275 8.67417 17.5758C8.32254 17.2242 8.125 16.7473 8.125 16.25C8.125 15.7527 8.32254 15.2758 8.67417 14.9242C9.02581 14.5725 9.50272 14.375 10 14.375C10.4973 14.375 10.9742 14.5725 11.3258 14.9242C11.6775 15.2758 11.875 15.7527 11.875 16.25ZM11.875 10C11.875 10.4973 11.6775 10.9742 11.3258 11.3258C10.9742 11.6775 10.4973 11.875 10 11.875C9.50272 11.875 9.02581 11.6775 8.67417 11.3258C8.32254 10.9742 8.125 10.4973 8.125 10C8.125 9.50272 8.32254 9.02581 8.67417 8.67417C9.02581 8.32254 9.50272 8.125 10 8.125C10.4973 8.125 10.9742 8.32254 11.3258 8.67417C11.6775 9.02581 11.875 9.50272 11.875 10ZM11.875 3.75C11.875 4.24728 11.6775 4.72419 11.3258 5.07583C10.9742 5.42746 10.4973 5.625 10 5.625C9.50272 5.625 9.02581 5.42746 8.67417 5.07583C8.32254 4.72419 8.125 4.24728 8.125 3.75C8.125 3.25272 8.32254 2.77581 8.67417 2.42417C9.02581 2.07254 9.50272 1.875 10 1.875C10.4973 1.875 10.9742 2.07254 11.3258 2.42417C11.6775 2.77581 11.875 3.25272 11.875 3.75Z",
    fill: "#6F6F6F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_8"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDotsVertical);
export default __webpack_public_path__ + "static/media/three-dots-vertical.679593b9082eb352aaef9fe66314a639.svg";
export { ForwardRef as ReactComponent };